import * as userActions from '../user/actions';
import * as allFOIVThemesActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const AllFOIVThemesReducer = (state = initialState, action) => {
    switch (action.type) {
        case allFOIVThemesActions.SET_ALL_FOIV_THEMES_FETCHING:
            return {
                ...initialState,
                isFetching: action.isFetching,
            };

        case allFOIVThemesActions.SET_ALL_FOIV_THEMES_ERROR:
            return {
                ...state,
                error: action.error,
                isFetching: false,
                isLoaded: true,
            };

        case allFOIVThemesActions.SET_ALL_FOIV_THEMES:
            return {
                list: action.list,
                isFetching: false,
                isLoaded: true,
                error: '',
            };

        case allFOIVThemesActions.ABORT_ALL_FOIV_THEMES_REQUEST:
            return initialState;

        case allFOIVThemesActions.CLEAN_ALL_FOIV_THEMES:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/AllFOIVThemes/reducer.js